import React from 'react';
import {AccentedSvgIcon, AccentedSvgIconProps} from './AccentedSvgIcon';

export const SolidPlayIcon = (props: AccentedSvgIconProps): JSX.Element => (
    <AccentedSvgIcon {...props} className="ue-icon-inner-play">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.63415 1.34528C3.87134 1.21274 4.16167 1.21885 4.39307 1.36126L17.3931 9.36126C17.6149 9.49776 17.75 9.73955 17.75 10C17.75 10.2604 17.6149 10.5022 17.3931 10.6387L4.39307 18.6387C4.16167 18.7811 3.87134 18.7873 3.63415 18.6547C3.39696 18.5222 3.25 18.2717 3.25 18V2C3.25 1.72829 3.39696 1.47783 3.63415 1.34528Z"
        />
    </AccentedSvgIcon>
);
